import { roundToTwoDecimals } from './mathHelpers.js';
import { __, divide } from 'ramda';

// Structure vide des intervalles RO
export const EMPTY_RO_INTERVALS = {
  labels: [],
  ROs: [],
  rows: [],
  note: '',
  intervals: []
};

// Note affichée dans les graphiques
export const RO_DISCLAIMER_NOTE = '*Le montant versé par le Régime Obligatoire peut varier en fonction du nombre d\'enfants à charge pour certaines caisses';

// Labels des tabs de franchise
export const TAB_LABELS = {
  MALADIE: 'Maladie',
  ACCIDENT: 'Accident',
  HOSPI: 'Hospi'
};

export const createIntervalLabel = (plafondMin, plafondMax) => {
  return `${plafondMin} à ${plafondMax} jours`;
};

const franchiseLabelMap = {
  [TAB_LABELS.MALADIE]: 'maladie',
  [TAB_LABELS.ACCIDENT]: 'accident',
  [TAB_LABELS.HOSPI]: 'hospi'
};

export const getFranchiseForTab = (tab, franchiseMap) => {
  const key = franchiseLabelMap[tab.label];
  if (!key) return null;

  const value = franchiseMap[key];
  return value ? parseFloat(value) || null : null;
};

export const calculateDailyBaseAmount = (annualIncome, percentage) => {
  const amount = (annualIncome * percentage) / 100 / 365;
  return roundToTwoDecimals(amount);
};

export const calculateDailyRevenue = divide(__, 365);
